import '../webpack';
import { initSentry } from './init_sentry';

initSentry();
